import React from 'react'
import "../style/bottom_style.css"

export default function Bottom() {
  return (
    <div>
        <div className='footer'>
            Made With Love By <a href="https://www.linkedin.com/in/shubhankar-86068222b/" className='shub_link'> Shubhankar </a> For Hack-ccelerate
        </div>
    </div>
  )
}
